<template>
    <div class="sa-tab-scroll">
        <b-card v-for="(section, index) in sections" class="sa-card" :header="section.sezioneTitolo" header-tag="header" footer-tag="footer" :key="index">
            <!-- <p @click="onClickSisto">Sisto {{ formData }}</p> -->
            <b-row v-show="formData && showForm" :key="keyIndex">
                <br />
                <b-col v-for="(element, index) in getJsonForm(section)" :cols="element.cols" :xs="element.xs" :sm="element.sm" :md="element.md" :lg="element.lg" :xl="element.xl" :key="index">
                    <label class="sa-label-data" v-if="element.label != null || element.label != ''"> {{ element.label }}:</label>
                    <template v-if="!isView">
                        <template v-if="element.type === 'input'">
                            <template v-if="!element.typedetail">
                                <b-form-input v-model="formData[element.modelName]" :disabled="!isEnabled(element)" @input="onChange(element)"></b-form-input>
                            </template>
                            <template v-else>
                                <b-form-input v-show="showForm" :type="element.typedetail" v-model="formData[element.modelName]" :disabled="!isEnabled(element)" @input="onChange(element)"></b-form-input>
                            </template>
                        </template>
                        <template v-if="element.type === 'datepicker'">
                            <template v-if="element.typedetail">
                                <template v-if="element.typedetail == 'datetime'">
                                    <date-picker :format="'DD/MM/YYYY HH:mm'" value-type="timestamp" v-model="formData[element.modelName]" :key="formData[element.modelName]" type="datetime"></date-picker>
                                </template>
                            </template>
                            <template v-else>
                                <date-picker :format="'DD/MM/YYYY'" value-type="timestamp" v-model="formData[element.modelName]" :key="formData[element.modelName]" type="date"></date-picker>
                            </template>
                        </template>
                        <template v-if="element.type === 'datepickernodefault'">
                            <template v-if="element.typedetail">
                                <template v-if="element.typedetail == 'datetime'">
                                    <date-picker :format="'DD/MM/YYYY HH:mm'" value-type="timestamp" v-model="formData[element.modelName]" :key="formData[element.modelName]" type="datetime"></date-picker>
                                </template>
                            </template>
                            <template v-else>
                                <date-picker :format="'DD/MM/YYYY'" value-type="timestamp" v-model="formData[element.modelName]" :key="formData[element.modelName]" type="date"></date-picker>
                            </template>
                        </template>
                        <template v-if="element.type === 'select'">
                            <b-form-select v-model="formData[element.modelName]" :options="element.dataOptions" :value="null" value-field="value" text-field="text" :disabled="element.disabled === true || element.readonly === true || !isEnabled(element)" @change="onChange(element)">
                                <template #first>
                                    <b-form-select-option :value="null" disabled> - Seleziona Valore - </b-form-select-option>
                                </template>
                            </b-form-select>
                        </template>
                        <template v-if="element.type === 'textarea'">
                            <b-form-textarea v-model="formData[element.modelName]" rows="7"></b-form-textarea>
                        </template>
                        <template v-if="element.type === 'checkbox'">
                            <b-form-checkbox v-model="formData[element.modelName]" :disabled="!isEnabled(element)" @change="onChange(element)" :value="element.checkbox.checkedValue" :unchecked-value="element.checkbox.notCheckedValue" switch> </b-form-checkbox>
                        </template>
                        <template v-if="element.type === 'span'">
                            <span>{{ formData[element.modelName] }}</span>
                        </template>
                        <template v-if="element.type === 'calculate'">
                            <b-form-input :disabled="true" v-model="formData[element.modelName]"></b-form-input>
                        </template>
                        <!-- <template v-if="element.type === 'table'">
								<div v-for="(gruppoItem, index) in gruppoItems(element)" :key="index">
									<p>{{ gruppoItem.label }}</p>
									<b-table sticky-header ref="table" stacked="sm" striped hover :items="gruppoItem.items" :fields="element.table.fields" :current-page="1" :per-page="1000000" sort-icon-left head-variant="light" class="sa-b-table" thead-class="hidden-header">
										<template #cell(fattore)="item">
											{{ item.item.fattore }}
										</template>
										<template #cell(check)="{ item }">
											<b-form-select
												v-if="item.inputType === 'SELECT'"
												id="inline-form-custom-select-pref"
												class="mb-2 mr-sm-2 mb-sm-0"
												v-model="item.punteggio"
												:value="null"
												value-field="value"
												text-field="text"
												:options="item.punteggioOptions"
												:disabled="isModalView"
												@change="onChangePunteggio(item)"
											>
												<template #first>
													<b-form-select-option :value="null" disabled> -Seleziona un'opzione- </b-form-select-option>
												</template>
											</b-form-select>
											<b-form-checkbox v-else v-model="item.check" :checked="item.check" :disabled="isModalView" switch></b-form-checkbox>
										</template>
									</b-table>
								</div>
							</template>-->
                    </template>
                    <template v-else>
                        <span v-if="element.type === 'datepicker'">
                            <template v-if="!element.typedetail">
                                {{ formatDate(formData[element.modelName]) }}
                            </template>
                            <template v-else>
                                {{ formatDateTime(formData[element.modelName]) }}
                            </template>
                        </span>
                        <span v-if="element.type === 'datepickernodefault'">
                            <template v-if="!element.typedetail">
                                {{ formatDate(formData[element.modelName]) }}
                            </template>
                            <template v-else>
                                {{ formatDateTime(formData[element.modelName]) }}
                            </template>
                        </span>

                        <span v-else-if="element.type === 'select'">{{ selecText(element.dataOptions, formData[element.modelName]) }}</span>
                        <span v-else-if="element.type === 'checkbox'">{{ getCheckBox(element.modelName) }}</span>
                        <span v-else>{{ formData[element.modelName] }}</span>
                    </template>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import moment from "moment";
import UtilityMixin from "../UtilityMixin";
export default {
    props: {
        jsonData: { type: Object },
        isView: {
            type: Boolean,
            default: () => {
                return false;
            },
        },
        /*   preview:{
            type: Boolean,
			default: () => {
				return false;
			},
        }*/
    },
    mixins: [UtilityMixin],
    components: { DatePicker },
    data() {
        return {
            keyIndex: 0,
            renderingDatePicker: false,
            formData: {}, //{ dataOra: new Date().getTime() },
            sections: [],
            tablesItems: [],
            isModalView: false,
            showForm: false,
        };
    },
    created() {
        // this.jsonData.jsonForm.forEach((element) => {
        // 	console.log(element);
        // 	this.formData[element.modelName] = null;
        // });
    },
    mounted() {
        if (this.jsonData.jsonForm)
            this.jsonData.jsonForm.forEach((element) => {
                if (element.type === "table") {
                    this.loadDataTable(element);
                }
            });
    },
    computed: {},
    watch: {
        "jsonData.jsonForm": {
            handler(value) {
                let me = this;
                me.formData = {};
                me.sections = [];
                this.showForm = false;
                if (value)
                    Object.entries(value).forEach(([chiave, valore]) => {
                        chiave;
                        if (valore.type === "select") {
                            this.$set(me.formData, valore.modelName, null);
                        } else if (valore.type === "datepicker") {
                            let timestamp = new Date().getTime();
                            this.$set(me.formData, valore.modelName, timestamp);
                        } else if (valore.type === "checkbox") {
                            this.$set(me.formData, valore.modelName, valore.checkbox.notCheckedValue);
                        } else if (valore.type === "input" && valore.typedetail == "number") {
                            this.$set(me.formData, valore.modelName, 0);
                        } else if (valore.type === "calculate") {
                            this.$set(me.formData, valore.modelName, 0);
                        } else if (valore.type === "datepickernodefault") {
                            this.$set(me.formData, valore.modelName, null);
                        }
                        let section;
                        if (valore.sezione && valore.sezione != "base") {
                            section = { sezione: valore.sezione, sezioneTitolo: valore.sezioneTitolo };
                        } else {
                            section = { sezione: "base", sezioneTitolo: this.jsonData.titolo };
                        }
                        this.sections.push(section);
                    });
                this.sections = [...new Map(this.sections.map((item) => [item["sezione"], item])).values()];
                this.showForm = true;
                let derivedTargets = this.jsonData.jsonForm.filter((element) => element.deriveFrom);
                derivedTargets.forEach((element) => {
                    if (!element.deriveRules || !element.deriveRules.length) return;
                    this.applyDerive(element);
                });
            },
            deep: true,
            immediate: true,
        },
    },
    methods: {
        isEnabled(element) {
            if (!element || !element.dependsOn) return true;
            let parentVal = this.formData[element.dependsOn];
            if (element.dependsOnValue !== undefined) {
                return parentVal === element.dependsOnValue;
            }
            return !!parentVal;
        },
        clearDependentFields(parentModel) {
            let list = (this.jsonData && this.jsonData.jsonForm) || [];
            let dependents = list.filter((element) => element.dependsOn === parentModel);
            dependents.forEach((element) => {
                let parentVal = this.formData[parentModel];
                let shouldEnable = element.dependsOnValue !== undefined ? parentVal === element.dependsOnValue : !!parentVal;
                if (!shouldEnable) {
                    let defaultVal = null;
                    if (element.type === "select") defaultVal = null;
                    else if (element.type === "datepicker") defaultVal = new Date().getTime();
                    else if (element.type === "checkbox") defaultVal = element.checkbox ? element.checkbox.notCheckedValue : false;
                    else if (element.type === "input" && element.typedetail === "number") defaultVal = 0;
                    else if (element.type === "calculate") defaultVal = 0;
                    else if (element.type === "datepickernodefault") defaultVal;
                    this.$set(this.formData, element.modelName, defaultVal);
                    if (element.formula) {
                        this.onChange(element);
                    }
                    this.clearDependentFields(element.modelName);
                }
            });
        },
        getCheckBox(chechbox) {
            //console.log("check", chechbox);
            //console.log(this.formData[chechbox]);
            if (this.formData[chechbox] === true) {
                return "Si";
            } else {
                return "No";
            }
        },
        gruppoItems(element) {
            let returnValue = [];
            let gruppiTmp = [];
            let pathName = process.env.VUE_APP_PATH_API + element.table.pathResources;
            let items = this.tablesItems[pathName] ? this.tablesItems[pathName].items : [];
            items.forEach((item) => {
                gruppiTmp.push(item[element.table.groupKeyItemName]);
            });
            gruppiTmp = [...new Set(gruppiTmp)];
            gruppiTmp.forEach((gruppo) => {
                returnValue.push({ label: gruppo, items: items.filter((el) => el[element.table.groupKeyItemName] === gruppo) });
            });

            return returnValue;
        },
        getItems(element) {
            let pathName = process.env.VUE_APP_PATH_API + element.table.pathResources;
            return this.tablesItems[pathName] ? this.tablesItems[pathName].items : [];
        },
        getJsonForm(sezione) {
            return this.jsonData.jsonForm.filter((e) => e.sezione === sezione.sezione || e.sezione === null);
        },
        selecText(array, valueElement) {
            //OTTIMO

            if (valueElement === null) return;
            if (!array) return;
            let returnValue = array.filter((a) => a.value == valueElement);
            return returnValue[0].text;
        },
        getDataFormattata(date) {
            let out = "";
            if (date) out = moment(new Date(date)).format("DD/MM/yyyy");
            return out;
        },
        getJsonData() {
            return this.formData;
        },
        setForm(value) {
            if (this.isView) {
                this.formData = { ...value };
            } else {
                let formDataCOnfigurato = this.formData;
                this.formData = { ...value, ...formDataCOnfigurato };
            }
        },
        resetForm() {
            this.formData = {};
        },
        onChange(element) {
            switch (element.formula) {
                case "SUM":
                    this.sum(element);
                    this.applyDerivationsFrom(element.formulaResult);
                    break;
                case "MOL":
                    this.mol(element);
                    break;
                case "AVG":
                    this.avg(element);
                    break;
            }
            if (this.jsonData && this.jsonData.jsonForm && this.jsonData.jsonForm.some((f) => f.dependsOn === element.modelName)) {
                this.clearDependentFields(element.modelName);
            }
        },
        sum(item) {
            this.formData[item.formulaResult] = 0;
            let sumElement = this.jsonData.jsonForm.filter((element) => element.formula === "SUM" && element.formulaResult === item.formulaResult);
            sumElement.forEach((el) => {
                let number = 0;
                if (el.type === "select" && el.typedetail === "samevalue") {
                    let value = this.formData[el.modelName];
                    if (value) {
                        let part = value.split("#");
                        number = Number(part[0]);
                    }
                } else {
                    number = this.formData[el.modelName];
                }
                this.formData[item.formulaResult] += number;
            });
            this.applyDerivationsFrom(item.formulaResult);
            this.keyIndex++;
        },
        mol(item) {
            this.formData[item.formulaResult] = 1;
            let molElement = this.jsonData.jsonForm.filter((element) => element.formula === "MOL" && element.formulaResult === item.formulaResult);
            molElement.forEach((el) => {
                let number = 1;
                if (el.type === "select" && el.typedetail === "samevalue") {
                    let value = this.formData[el.modelName];
                    if (value) {
                        let part = value.split("#");
                        number = Number(part[0]);
                    }
                } else {
                    number = this.formData[el.modelName];
                }
                this.formData[item.formulaResult] *= number;
            });
            this.jsonData.jsonForm
                .filter((element) => element.formula === "SUM")
                .forEach((sumElement) => {
                    this.sum(sumElement);
                });
            this.applyDerivationsFrom(item.formulaResult);
            this.keyIndex++;
        },
        avg(item) {
            let me = this;
            me.formData[item.formulaResult] = 0;
            let avgElement = me.jsonData.jsonForm.filter((element) => element.formula === "AVG" && element.formulaResult === item.formulaResult);
            let count = 0;
            let number = 0;
            let sum = 0;
            avgElement.forEach((el) => {
                if (el.type === "select" && el.typedetail === "samevalue") {
                    let value = me.formData[el.modelName];
                    if (value) {
                        let part = value.split("#");
                        number = Number(part[0]);
                    }
                } else {
                    number = me.formData[el.modelName];
                }
                sum = sum + number;
                count++;
            });
            me.formData[item.formulaResult] = sum / count;
            me.formData[item.formulaResult] = parseFloat(me.formData[item.formulaResult].toFixed(2));
        },
        loadDataTable(element) {
            let me = this;
            let pathName = process.env.VUE_APP_PATH_API + element.table.pathResources;
            this.tablesItems[pathName] = element;
            UtilityMixin.methods.loadDataResources(element.table.pathResources, {}, me.loadDataTableSuccess, me.loadDataTableError);
        },
        loadDataTableSuccess(response) {
            this.tablesItems[response.config.url].items = response.data.data.list;
            this.keyIndex++;
        },
        loadDataTableError(error) {
            console.log(error);
        },
        applyDerive(field) {
            let sourceValue = this.formData[field.deriveFrom];
            let derivedValue = null;

            for (let rule of field.deriveRules) {
                let hasEqual = Object.prototype.hasOwnProperty.call(rule, "eq");
                let hasRange = rule.min !== undefined && rule.max !== undefined;

                let matchesEqual = hasEqual && sourceValue === rule.eq;
                let matchesRange = hasRange && sourceValue >= rule.min && sourceValue <= rule.max;

                if (matchesEqual || matchesRange) {
                    derivedValue = rule.set !== undefined ? rule.set : rule.text ?? null;
                    break;
                }
            }

            this.$set(this.formData, field.modelName, derivedValue);
        },
        applyDerivationsFrom(chiave) {
            let targets = this.jsonData.jsonForm.filter((element) => element.deriveFrom === chiave);
            targets.forEach((element) => this.applyDerive(element));
        },
    },
};
</script>

<style></style>
